import type { ImageLoaderConfig } from '@angular/common'
import { ImageVariantUrl, pickVariant } from '@seiri/shared/common'

/** What `[loaderParams]` carries for `variantImageLoader`: the image's stored sizes (`ImageInfo.variants`). */
export interface VariantLoaderParams {
  variants: readonly ImageVariantUrl[]
}

/**
 * An `IMAGE_LOADER` for an uploaded image (docs/media.md): `NgOptimizedImage` asks for a width per `srcset` entry,
 * and this answers with the stored size that fills it (`pickVariant`). The sizes are fixed at upload, so the loader
 * picks one rather than building a resize URL. Without variants it falls back to `ngSrc` as given.
 */
export function variantImageLoader(config: ImageLoaderConfig): string {
  const variants = (config.loaderParams as VariantLoaderParams | undefined)?.variants ?? []
  if (!config.width) return config.src
  return pickVariant(variants, config.width)?.url ?? config.src
}
